import React from "react";
import { X, Copy } from "lucide-react";
import "./transaction-details.css";
import { useNavigate, useLocation } from "react-router-dom";

export default function TransactionDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const transaction = state?.transaction;

  const goBack = () => navigate(-1);

  if (!transaction) {
    return (
      <div className="transaction-container">
        <p>No transaction data found.</p>
        <button onClick={goBack}>Go Back</button>
      </div>
    );
  }

  const isDeposit = transaction.action === "deposit";
  const amount = Number(transaction.amount).toFixed(2);
  const createdAt = new Date(transaction.created_at).toLocaleString();

  const statusText =
    transaction.key === 1
      ? "Success"
      : transaction.key === 0
        ? "Processing"
        : "Failed";

  return (
    <div className="transaction-container">
      {/* Header */}
      <div className="transaction-header">
        <h1>Details</h1>
        <button onClick={goBack} className="close-button">
          <X size={20} />
        </button>
      </div>

      {/* Amount Display */}
      <div className="amount-section">
        <div className="amount-display">
          {isDeposit ? "+" : "-"} {amount}
        </div>
        <div className="amount-label">
          {isDeposit ? "Deposit Payment Gateway" : "Withdrawal"}
        </div>
      </div>

      {/* Status */}
      <StatusItem icon="✓" text={statusText} active />

      {/* Status Timeline */}
      <div className="status-section">
        <StatusItem
          icon="✓"
          text={`${isDeposit ? "Deposit" : "Withdrawal"} processed`}
          subtext={createdAt}
          completed
        />
        <StatusItem
          icon="○"
          text="Transaction received"
          subtext={createdAt}
        />
        <StatusItem
          icon="○"
          text="Transaction initiated"
          subtext={createdAt}
        />
      </div>

      {/* Transaction Details */}
      <div className="details-section">
        <DetailRow label="No." value={transaction.id} />
        <DetailRow
          label="Type"
          value={isDeposit ? "Deposit Payment Gateway" : "Withdrawal"}
        />
        <DetailRow
          label="Payment Method"
          value={transaction.payment_method || "—"}
          hasIcon
        />
        <DetailRow
          label="Payment Type"
          value={isDeposit ? "Deposit" : "Withdrawal"}
        />
        <DetailRow
          label="Transaction NO."
          value={transaction.transaction_id}
          copyable
        />
        <DetailRow
          label="Amount"
          value={`${isDeposit ? "+" : "-"} ${amount}`}
          highlighted
        />
      </div>

      {/* Close Button */}
      <button onClick={goBack} className="close-btn-bottom">
        Close
      </button>
    </div>
  );
}

/* -----------------------------
   Helper Components (UNCHANGED)
------------------------------*/
function StatusItem({ icon, text, subtext, active, completed }) {
  return (
    <div
      className={`status-item ${active ? "active" : ""} ${completed ? "completed" : ""
        }`}
    >
      <div className="status-icon">{icon}</div>
      <div className="status-content">
        <div className="status-text">{text}</div>
        {subtext && <div className="status-subtext">{subtext}</div>}
      </div>
    </div>
  );
}

function DetailRow({ label, value, hasIcon, copyable, highlighted }) {
  const copyText = () => navigator.clipboard.writeText(value);

  return (
    <div className="detail-row">
      <div className="detail-label">{label}</div>
      <div className={`detail-value ${highlighted ? "highlighted" : ""}`}>
        {hasIcon && <span className="payment-badge">🔺</span>}
        <span>{value}</span>
        {copyable && (
          <button className="copy-button" onClick={copyText}>
            <Copy size={14} />
          </button>
        )}
      </div>
    </div>
  );
}